import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class BlockTransitionModal extends Component {
  render() {
    const { onConfirm, onCancel } = this.props;
    return (
      <Modal isOpen={true} toggle={onCancel}>
        <ModalHeader toggle={onCancel}>UWAGA!</ModalHeader>
        <ModalBody>
          Dane nie zostały zapisane. Czy na pewno chcesz opuścić formularz?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={onConfirm}>
            Opuść formularz
          </Button>{" "}
          <Button color="primary" onClick={onCancel}>
            Cofnij
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const getUserConfirmation = (message, callback) => {
  const modal = document.createElement("div");
  document.body.appendChild(modal);

  const withCleanup = answer => {
    ReactDOM.unmountComponentAtNode(modal);
    document.body.removeChild(modal);
    callback(answer);
  };

  ReactDOM.render(
    <BlockTransitionModal
      message={message}
      onCancel={() => withCleanup(false)}
      onConfirm={() => withCleanup(true)}
    />,
    modal
  );
};

export default getUserConfirmation;



// WEBPACK FOOTER //
// ./src/app/getUserConfirmation.js